<template>
  <div class="top">
    <p class="title fw700" :style="{ 'line-height': '42px', color: '#0F1734' }">Profile Reviews</p>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading">
      <div class="mob" style="margin-top: 48px; margin-bottom: 24px; display: flex; justify-content: space-between">
        <p class="result-length">
          <!-- {{ reviews.paginator.total_count }} Results {{ browseFilterType }} -->
          {{ reviews.length }} {{ reviews.length > 1 ? "Results" : "Result" }}
        </p>
        <a-dropdown :style="{ cursor: 'pointer', 'margin-top': '7px' }">
          <p class="sort-text">
            Show
            <span style="font-weight: 700">{{ sortOption }}</span>
            <font-awesome-icon @click="expand = !expand" size="lg" style="margin-left: 8px" :icon="['fas', 'angle-down']" />
            <!-- v-if="!expand" -->
          </p>
          <template #overlay>
            <a-menu @click="e => sortReviews(e.key)">
              <a-menu-item key="doctor">Physician Reviews</a-menu-item>
              <!-- <a-menu-item key="hospital_administrator">Hospital Reviews</a-menu-item> -->
              <!-- <a-menu-item key="clinic_administrator">Clinic Reviews</a-menu-item> -->
              <a-menu-item key="hcp">Advanced Practice Provider Reviews</a-menu-item>
              <!-- <a-menu-item key="nty">Business Reviews</a-menu-item> -->
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div>
        <ReviewCard v-for="review in reviews" :reviewData="review" :key="review" />
      </div>
    </div>
    <div v-if="!loading && reviews.length === 0">
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">You did not review any profile yet.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ReviewCard from "../../home/reviews/ReviewCard.vue"
import ReviewCard from "../../home/reviews/ReviewTabCard.vue"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { faThemeisle } from "@fortawesome/free-brands-svg-icons"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientProfileReview",
  components: {
    ReviewCard,
  },

  data() {
    return {
      reviews: [],
      loading: true,
      sortKey: "doctor",
      sortOption: "Physician Reviews",
    }
  },

  created() {
    console.warn("PatientProfileReview.vue is created")
    this.fetch()
  },

  methods: {
    sortReviews(sort) {
      this.sortKey = sort
      this.sortOption =
        sort === "doctor"
          ? "Physician Reviews"
          : sort === "hospital_administrator"
          ? "Hospital Reviews"
          : sort === "clinic_administrator"
          ? "Clinic Reviews"
          : sort === "hcp"
          ? "Advanced Practice Provider Reviews"
          : "Business Reviews"
      this.fetch()
    },

    fetch() {
      this.loading = true
      UserRepository.getProfileReviews(1, 10, this.currentCircle.id, this.authUser.user.id, this.authUser.user.role, this.sortKey)
        .then(res => {
          // this.reviews = res.data.data.data ? res.data.data.data : []
          if (res.data.message === "found") {
            this.reviews = res.data.data
          } else {
            this.reviews = []
          }
          // console.log("res.data:", res.data)
          this.loading = false
        })
        .catch(e => {
          this.reviews = []
        })
    },
  },
}
</script>

<style scoped lang="scss">
.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
.mob {
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
}

.result-length {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}

.top {
  width: 100%;
}

.title {
  font-size: 32px;

  @media screen and (max-width: 700px) {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/PatientProfileReview.vue